import "../../assets/scss/custom/_badge.scss";

interface BadgeProps {
  tone: "neutral" | "info";
  children: React.ReactNode;
  title?: string;
}

// Minimal Wellinks-DS-style badge primitive. Introduced for the Patient
// Summary redesign (design_handoff_patient_summary, option 2a) - swap this
// for the real Wellinks DS Badge component if/when that package is
// integrated into the app.
export const Badge = ({ tone, children, title }: BadgeProps) => (
  <span className={`ds-badge ds-badge--${tone}`} title={title}>
    {children}
  </span>
);
